import { render, staticRenderFns } from "./GRegionsPercentile.vue?vue&type=template&id=368c5926&"
import script from "./GRegionsPercentile.vue?vue&type=script&lang=js&"
export * from "./GRegionsPercentile.vue?vue&type=script&lang=js&"
import style0 from "./GRegionsPercentile.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports